import { useCallback } from "react";

import type { PlainWidgetInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../query";
import { PLAIN_WIDGET_FOR_DESIGN_PLAIN_MUTATION } from "./schema";

export const usePlainWidgetMutation = () => {
	const { mutationFunc } = useCustomMutation(PLAIN_WIDGET_FOR_DESIGN_PLAIN_MUTATION);

	const onUpdatePlainWidget = useCallback(
		async (input: PlainWidgetInput) => {
			return mutationFunc({
				variables: { input },
				refetchQueries: [
					{ query: Query.PLAIN_WIDGET_FOR_DESIGN_PLAIN_QUERY, variables: { hotelID: input.hotelID } },
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdatePlainWidget,
	};
};
